<template>
  <div>
    <data-table class="table-custom" ref="dataTable" :option="option">
      <template #footerContent>
        <div class="total-info">
          总数量：<span>{{ totalInfo.TotalQuantity }}</span> 总金额：<span>{{
            totalInfo.TotalPrice
          }}</span>
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
export default {
  components: {
    DataTable
  },
  data() {
    return {
      option: {},
      DisplayZeroStock: false,
      totalInfo: {}
    };
  },
  created() {
    const _this = this;
    //形成表格表单
    _this.option = {
      //搜索框内容
      headSearch: {
        colnum: 5,
        content: [
          {
            label: "仓库",
            name: "WarehouseId",
            type: "select",
            api: "Common_GetSelect",
            param: {
              Types: "Warehouse"
            },
            dataField: "Data.Warehouse",
            defaultSelect: true,
            load: data => {
              if (data && data.length) {
                this.$nextTick(() => {
                  this.$refs.dataTable.headSearchFormData = {
                    WarehouseId: data[0].Id,
                    DisplayZeroStock: this.DisplayZeroStock
                  };
                });
              }
            },
            onChange: () => {
              _this.$refs.dataTable.headSearch();
            },
            option: {
              rules: [{ required: true, message: "请选择仓库" }]
            }
          },
          {
            label: "物品类别",
            name: "GoodCategoryId",
            type: "select",
            api: "Common_GetSelect",
            param: {
              Types: "GoodsCategory"
            },
            dataField: "Data.GoodsCategory"
          },
          {
            label: "物品名",
            name: "Keyword",
            props: {
              placeholder: "商品名称"
            }
          },
          {
            label: " ",
            colon: false,
            name: "DisplayZeroStock",
            type: "checkbox",
            option: {
              initialValue: false
            },
            width: "30px",
            after: () => {
              return "不显示0库存";
            },
            onChange: e => {
              _this.DisplayZeroStock = e.target.checked;
              _this.$refs.dataTable.headSearch();
            }
          },
          {
            label: " ",
            colon: false,
            name: "LessThanMinStock",
            type: "checkbox",
            option: {
              initialValue: false
            },
            width: "30px",
            after: () => {
              return "低于最小库存";
            },
            onChange: () => {
              setTimeout(() => {
                _this.$refs.dataTable.headSearch();
              }, 100);
            }
          }
        ],
        onSubmitBefore: values => {
          values.DisplayZeroStock = !_this.DisplayZeroStock;
          // values.PageIndex = 0;
          return values;
        }
      },
      //表格内容
      grid: {
        // delSelecteds: true,
        api: "Warehouse_GoodsGet", //数据表格api
        autoLoad: false,
        props: {
          scroll: {
            y: window.document.body.clientHeight - 320
          }
        },
        columns: [
          {
            title: "序号",
            width: "8%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "物品名称",
            dataIndex: "GoodsName",
            align: "center"
          },
          {
            title: "物品编码",
            dataIndex: "GoodsCode",
            width: "15%",
            align: "center"
          },
          {
            title: "物品类别",
            dataIndex: "GoodsCategoryName",
            width: "15%",
            align: "center"
          },
          {
            title: "库存单位",
            dataIndex: "UnitName",
            width: "8%",
            align: "center"
          },
          {
            title: "平均单价",
            dataIndex: "AvgPrice",
            width: "8%",
            align: "right"
          },
          {
            title: "库存数量",
            dataIndex: "Quantity",
            width: "8%",
            align: "center"
          },
          {
            title: "库存金额",
            width: "10%",
            dataIndex: "TotalPrice",
            align: "right"
          }
        ],
        loadData: data => {
          this.totalInfo = data.Data.Other;
        },
        pageChange: json => {
          return {
            ...json,
            DisplayZeroStock: !_this.DisplayZeroStock
          };
        }
      }
    };
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.table-custom {
  /deep/ .head {
    /deep/ .head-search-box {
      /deep/ .ant-form-item-label {
        width: 120px;
      }
    }
  }
  /deep/ .body {
    .data-grid-footer-action {
      width: 100%;
      height: 50px;
      bottom: 35px;
    }
    .total-info {
      position: absolute;
      right: 0;
      bottom: 10px;
      span {
        color: #f00;
        font-size: 20px;
        margin-right: 40px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  /deep/ .ant-table-pagination.ant-pagination {
    margin-top: 50px;
  }
}
</style>
